import { AiFilterValues } from '@kimuno/api-sdk/lib/types/responses/Text';
import immutable from 'object-path-immutable';
import { StoreItem } from '.';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import {
  FetchAiFilterValuesAction,
  FETCH_AI_FILTER_VALUES,
} from '../actions/aiFilterValues.actionTypes';

type AiFilterValuesActionTypes =
  | FetchAiFilterValuesAction;

export type AiFilterValuesState = StoreItem<AiFilterValues>;

const initialState: AiFilterValuesState = {
  data: { schoolTypes: [], subjects: [], classYears: [] },
  status: AsyncActionStatus.INITIAL,
};

const aiFilterValues = (state = initialState, action: AiFilterValuesActionTypes) => {
  switch (action.type) {
    case FETCH_AI_FILTER_VALUES.START:
      return immutable(state)
        .set('status', AsyncActionStatus.LOADING)
        .value();

    case FETCH_AI_FILTER_VALUES.SUCCESS:
      return immutable(state)
        .set('data', action.result)
        .set('status', AsyncActionStatus.READY)
        .value();

    case FETCH_AI_FILTER_VALUES.ERROR:
      return immutable(state)
        .set('error', action.error.message)
        .set('status', AsyncActionStatus.ERROR)
        .value();

    default:
      return state;
  }
};

export default aiFilterValues;
